import { useEffect, useState } from 'react';

import useIsAdmin from 'hooks/useIsAdmin';

import { cardHolderIdEnabled } from 'lib/models/profile';

function useCardHolderIdEnabled() {
	const [loading, setLoading] = useState(true);
	const [enabled, setEnabled] = useState(false);

	const isAdmin = useIsAdmin();

	useEffect(() => {
		const load = async () => {
			if (isAdmin) {
				const isEnabled = await cardHolderIdEnabled();
				if (isEnabled) {
					setEnabled(true);
				}
			}
			setLoading(false);
		};

		load();
	}, [isAdmin]);

	return { loading, enabled };
}

export default useCardHolderIdEnabled;
